import Http from './http'
import Servers from './servers'
import Client from './client'
import ClientOrder from './client-order'
import Comments from "./comments";
import Simcard from './simcard'
import Dashboard from './dashboard'
import Support from './support'
import Settings from './settings'
import User from './user'
import Rbac from './rbac'
import Status from './status'
import Utilities from './utilities'
import Notification from './notification'
//device
import Device from './device'
import Device_Rpc from './device-rpc'
import Device_Location from './device-location'
import Device_Group from './device-group'
import Device_Statistic from './device-statistic'
import Device_Task from './device-task'
import Device_Test from './device-test'
import Device_Traffic_Alerts from "./device-traffic-alerts";
import Device_List from './device-list'
import Device_Simcard_Group from './devicesimcardgroup'
import Device_Snapshot from "./device-snapshot"
import CompanyServices from "./company-services"


export default {
  ...Http,
  ...Device_Location,
  ...Servers,
  ...Simcard,
  ...Dashboard,
  ...Device,
  ...Device_Rpc,
  ...Device_Statistic,
  ...Device_Task,
  ...Device_Test,
  ...Device_Traffic_Alerts,
  ...Device_List,
  ...Device_Snapshot,
  ...Device_Simcard_Group,
  ...Support,
  ...Settings,
  ...User,
  ...Rbac,
  ...Client,
  ...ClientOrder,
  ...Comments,
  ...Device_Group,
  ...Utilities,
  ...Status,
  ...Notification,
  ...CompanyServices
}
